"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _url = _interopRequireDefault(require("url"));

var _AnnotationCollection = _interopRequireDefault(require("../models/AnnotationCollection"));

var _Annotation = _interopRequireDefault(require("../models/Annotation"));

var _Payloads = require("./Payloads");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Transforms returning ACP payloads into backwards-compatible format.  Opposite direction processing
 * is provided by Payloads.js
 */
var TransformResponse = /*#__PURE__*/function () {
  /**
   * Initializes.
   *
   * @param   {bool}  isACP     True for ACP responses
   * @param   {string}  anUrl   Request url
   * @param   {object}  response  Response to transform
   */
  function TransformResponse(isACP, anUrl, response) {
    _classCallCheck(this, TransformResponse);

    this._payload = response;
    this._url = anUrl;
    this._isACP = isACP;
    this._headers = response.headers;
  }
  /**
   * Performs transformation for ACP only payloads.
   *
   * @return  {object}  AnnotationCollection or Annotation model objects.
   */


  _createClass(TransformResponse, [{
    key: "transform",
    value: function transform() {
      var transformed = this._isACP ? this.transformPayloadToExpected() : this._payload;
      var result = null;

      if (transformed.data.type) {
        switch (transformed.data.type) {
          case 'AnnotationCollection':
            result = new _AnnotationCollection["default"](transformed.data, this._headers);
            return result;

          case 'Annotation':
            result = new _Annotation["default"](transformed.data, this._headers);
            return result;

          default:
            throw new Error('unknown result type');
        }
      } else if (transformed.data.responses && transformed.data.responses.length) {
        // Batch update calls
        var responses = transformed.data.responses;
        result = {};
        responses.forEach(function (response) {
          var id = response.body.id;

          if (response.status === 200) {
            result[id] = new _Annotation["default"](response.body.content);
          } else {
            result[id] = response.body.msg;
          }
        });
        return result;
      } else {
        throw new Error('unknown result type');
      }
    }
    /**
     * Performs transformation for AnnotationCollection or Annotation ACP API responses.
     *
     * @return  {json}           backwards compatible json describing AnnotationCollection or Annotation responses
     */

  }, {
    key: "transformPayloadToExpected",
    value: function transformPayloadToExpected() {
      var _this = this;

      var payload = {
        data: {}
      };
      var data = this._payload.data;

      if (data.children) {
        payload.data.total = data.children ? data.children.length : 0;
        payload.data.type = 'AnnotationCollection'; // embedded:primary payload format is *only* on annotation collection responses.

        payload.data['adobe:annotCollectionMetadata'] = this.transformMetaData(data[_Payloads.PL.P_ANNOTDATA]);
        var newItems = [];
        var items = data.children;
        items.forEach(function (item) {
          newItems.push(_this.transformItemPayload(true, item));
        });
        payload.data.first = {};
        payload.data.first.items = newItems;
      } else {
        payload.data = this.transformItemPayload(false, data);
      }

      return payload;
    }
    /**
     * Transforms an item's ACP metadata response.
     *
     * @param   {json}  item  json data to be transformed
     *
     * @return  {json}        backwards compatible json
     */

  }, {
    key: "transformMetaData",
    value: function transformMetaData(item) {
      var _this2 = this;

      var meta = {};
      item.forEach(function (ea) {
        var obj = _this2.transformPerson(ea);

        meta[obj.id] = obj;
      });
      return {
        'adobe:userInfo': meta
      };
    }
    /**
     * Returns links header
     *
     * @return  {string[]}  The links header
     */

  }, {
    key: "getLinks",
    value: function getLinks() {
      var linkString = this._headers.link;
      return linkString ? linkString.split('<') : [];
    }
    /**
     * Parses the url representing the current annotation from links.
     *
     * @param   {string[]}  links  The links header
     *
     * @return  {string}    An annotation url
     */

  }, {
    key: "parseAnnotUrl",
    value: function parseAnnotUrl(links) {
      for (var count = 0; count < links.length; count += 1) {
        var item = links[count];

        if (item && item.includes(_Payloads.PRIMARY_LINKREL)) {
          var src = item.substring(0, item.indexOf('>'));
          return src;
        }
      }

      return '';
    }
    /**
     * Transforms the top-level ACP item elements.
     *
     * @param   {bool}  isAnnotCollection  true if item is a collection
     * @param   {json}  item               the item response to be transformed
     *
     * @return  {json}                     the backwards compatible transformed item
     */

  }, {
    key: "transformItemPayload",
    value: function transformItemPayload(isAnnotCollection, item) {
      var anItem = {};
      anItem.type = 'Annotation'; // embedded:primary payload format is *only* on annotation collection responses.

      var subItem = isAnnotCollection ? item[_Payloads.PL.P_EMBEDDED][_Payloads.PL.P_PRIMARY_URL] : item;
      anItem.status = subItem[_Payloads.PL.P_STATUS];
      anItem.creator = this.transformCreator(subItem[_Payloads.PL.P_CREATOR]);
      anItem.motivation = subItem[_Payloads.PL.P_MOTIVATION];
      anItem.bodyValue = subItem[_Payloads.PL.P_BODY].value;
      anItem.target = this.transformTarget(subItem[_Payloads.PL.P_TARGET]);
      anItem['@context'] = ''; // Meta-data is returned as part of annot collection responses.

      if (isAnnotCollection) {
        anItem.url = item['repo:path'];
      } else {
        anItem.url = this.parseAnnotUrl(this.getLinks());
      }

      if (anItem.url) {
        var parsed = _url["default"].parse(anItem.url, true);

        anItem.id = "".concat(parsed.path);
      } else {
        throw new Error('Cannot locate link or path from annotation');
      } // Meta-data is returned as part of annot collection responses.


      anItem.etag = isAnnotCollection ? item['repo:etag'] : this._headers.etag; // Meta-data is returned as part of annot collection responses.

      var now = new Date().toISOString();
      now = "".concat(now.substring(0, now.length - 5), "Z");
      anItem.created = isAnnotCollection ? item['repo:createDate'] : now;
      anItem.modified = isAnnotCollection ? item['repo:modifyDate'] : now;
      anItem.mentions = this.transformMentions(subItem);
      return anItem;
    }
    /**
     * Transforms the mentions response.
     *
     * @param   {json}  item  the item response to be transformed
     *
     * @return  {json[]} the backwards compatible mentions list
     */

  }, {
    key: "transformMentions",
    value: function transformMentions(item) {
      var _this3 = this;

      var mentions = [];

      if (item[_Payloads.PL.P_MENTIONS]) {
        item[_Payloads.PL.P_MENTIONS].forEach(function (mention) {
          mentions.push(_this3.transformPerson(mention));
        });
      }

      return mentions;
    }
    /**
     * Transforms an user id.
     *
     * @param   {string}  id  a user's adobe-id
     *
     * @return  {string}  backwards compatible id
     */

  }, {
    key: "transformId",
    value: function transformId(id) {
      if (id) {
        return id.startsWith('urn:uuid:') ? id : "urn:uuid:".concat(id);
      }

      return '';
    }
    /**
     * Transforms the creator's meta data response
     *
     * @param   {json}  item  the item response to be transformed
     *
     * @return  {json}        backwards compatible meta-data
     */

  }, {
    key: "transformCreator",
    value: function transformCreator(item) {
      return this.transformPerson(item);
    }
    /**
     * Transforms the meta data response
     *
     * @param   {json}  item  the item response to be transformed
     *
     * @return  {json}        backwards compatible meta-data
     */

  }, {
    key: "transformPerson",
    value: function transformPerson(item) {
      var id = this.transformId(item['xdm:id']);
      var obj = {
        name: item['xdm:displayName'] ? item['xdm:displayName'] : '',
        id: id,
        type: item['xdm:type'],
        // TODO: compat?
        email: item['xdm:id']
      };

      if (item['xdm:profileImage']) {
        obj.img = item['xdm:profileImage'];
      }

      if (item['xdm:identityProvider']) {
        obj.affiliation = item['xdm:identityProvider'];
      }

      return obj;
    }
    /**
     * Transforms target id or index values.
     *
     * @param   {json}  item  the item response to be transformed
     * @param   {json}  target  the target portion to be updated
     *
     * @return  {json}          transformed target
     */

  }, {
    key: "transformTargetId",
    value: function transformTargetId(item, target) {
      if (item) {
        if (item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR]) {
          if (item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_ID]) {
            target.selector.node = {
              id: item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_ID]
            };
          } else {
            target.selector.node = {
              index: item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_INDEX]
            };
          }
        }
      }

      return target;
    }
    /**
     * Transforms the target portion of a ACP response.
     *
     * @param   {json}  item  the item response to be transformed
     *
     * @return  {json}        backwards compatible selector
     */

  }, {
    key: "transformTarget",
    value: function transformTarget(item) {
      var target = {
        source: item[_Payloads.PL.P_SOURCE]
      };

      if (item[_Payloads.PL.P_SELECTOR]) {
        target.selector = {
          type: 'AdobeAnnoSelector'
        };

        if (item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_TYPE] === 'node') {
          target.selector.subtype = 'node';
          this.transformTargetId(item, target);
        } else if (item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_TYPE] === 'note') {
          target.selector.subtype = 'note';
          this.transformTargetId(item, target);
          target.selector.noteX = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_NOTEX];
          target.selector.noteY = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_NOTEY];
          target.selector.strokeColor = item[_Payloads.PL.P_ANNOT_STYLE][_Payloads.PL.P_ANNOT_STROKECOLOR];
        } else if (item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_TYPE] === 'shape') {
          target.selector.subtype = 'shape';
          this.transformTargetId(item, target);
          target.selector.opacity = item[_Payloads.PL.P_ANNOT_STYLE][_Payloads.PL.P_ANNOT_OPACITY];
          target.selector.strokeColor = item[_Payloads.PL.P_ANNOT_STYLE][_Payloads.PL.P_ANNOT_STROKECOLOR];
          target.selector.strokeWidth = item[_Payloads.PL.P_ANNOT_STYLE][_Payloads.PL.P_ANNOT_STROKEWIDTH];
          target.selector.boundingBox = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_BOUNDINGBOX];
          target.selector.inkList = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_INKLIST];
        } else if (item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_TYPE] === 'highlight' || item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_TYPE] === 'replace' || item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_TYPE] === 'strikeout') {
          target.selector.subtype = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_TYPE];
          this.transformTargetId(item, target);
          target.selector.opacity = item[_Payloads.PL.P_ANNOT_STYLE][_Payloads.PL.P_ANNOT_OPACITY];
          target.selector.strokeColor = item[_Payloads.PL.P_ANNOT_STYLE][_Payloads.PL.P_ANNOT_STROKECOLOR];
          target.selector.strokeWidth = item[_Payloads.PL.P_ANNOT_STYLE][_Payloads.PL.P_ANNOT_STROKEWIDTH];
          target.selector.boundingBox = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_BOUNDINGBOX];
          target.selector.quadPoints = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_PRIMARY_SELECTOR][0][_Payloads.PL.P_QUADPOINTS];
        }

        if (item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_REFINEDBY]) {
          target.selector.sectionId = item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_REFINEDBY][_Payloads.PL.P_STARTSTRUCTELEM];
          target.selector.refinedBy = {
            type: 'AdobeDynamicViewSelector',
            leftOffset: item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_REFINEDBY][_Payloads.PL.P_LEFTOFFSET],
            topOffset: item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_REFINEDBY][_Payloads.PL.P_TOPOFFSET],
            startStructId: item[_Payloads.PL.P_SELECTOR][_Payloads.PL.P_REFINEDBY][_Payloads.PL.P_STARTSTRUCTELEM]
          };
        }
      }

      return target;
    }
  }]);

  return TransformResponse;
}();

exports["default"] = TransformResponse;